
export const constants = {

  // WORKSPACE
  PACIENTES_INIT_WORKSPACE: 'PACIENTES_INIT_WORKSPACE',
  PACIENTES_INIT_WORKSPACE_SUCCESS: 'PACIENTES_INIT_WORKSPACE_SUCCESS',
  PACIENTES_SET_WORKSPACE: 'PACIENTES_SET_WORKSPACE',

  // SEARCH KEYWORD
  PACIENTES_SET_KEYWORD: 'PACIENTES_SET_KEYWORD',
  PACIENTES_SET_KEYWORD_STATE: 'PACIENTES_SET_KEYWORD_STATE',
  PACIENTES_SET_FILTER_TIENDA_STATE: 'PACIENTES_SET_FILTER_TIENDA_STATE',

  // REQUESTS
  // - CREATE PACIENTE
  PACIENTES_CREATE_PACIENTE_REQUEST: 'PACIENTES_CREATE_PACIENTE_REQUEST',
  PACIENTES_CREATE_PACIENTE_REQUEST_SUCCESS: 'PACIENTES_CREATE_PACIENTE_SUCCESS',
  PACIENTES_CREATE_PACIENTE_REQUEST_FAILURE: 'PACIENTES_CREATE_PACIENTE_FAILURE',
  // - CREATE PACIENTE
  COMPROBAR_PACIENTE_DUPLICADO_REQUEST: 'COMPROBAR_PACIENTE_DUPLICADO_REQUEST',
  COMPROBAR_PACIENTE_DUPLICADO_SUCCESS: 'COMPROBAR_PACIENTE_DUPLICADO_SUCCESS',
  COMPROBAR_PACIENTE_DUPLICADO_FAILURE: 'COMPROBAR_PACIENTE_DUPLICADO_FAILURE',

  // - UPDATE PACIENTE
  PACIENTES_UPDATE_PACIENTE_REQUEST: 'PACIENTES_UPDATE_PACIENTE_REQUEST',
  PACIENTES_UPDATE_PACIENTE_REQUEST_SUCCESS: 'PACIENTES_UPDATE_PACIENTE_SUCCESS',
  PACIENTES_UPDATE_PACIENTE_REQUEST_FAILURE: 'PACIENTES_UPDATE_PACIENTE_FAILURE',

  // - GET PACIENTES
  PACIENTES_GET_PACIENTES_REQUEST: 'PACIENTES_GET_PACIENTES_REQUEST',
  PACIENTES_GET_PACIENTES_REQUEST_SUCCESS: 'PACIENTES_GET_PACIENTES_SUCCESS',
  PACIENTES_GET_PACIENTES_REQUEST_FAILURE: 'PACIENTES_GET_PACIENTES_FAILURE',
  PACIENTES_GET_PACIENTES_REQUEST_NOT_UPDATE: 'PACIENTES_GET_PACIENTES_REQUEST_NOT_UPDATE',

  // - GET PACIENTE
  PACIENTES_GET_PACIENTE_REQUEST: 'PACIENTES_GET_PACIENTE_REQUEST',
  PACIENTES_GET_PACIENTE_REQUEST_SUCCESS: 'PACIENTES_GET_PACIENTE_SUCCESS',
  PACIENTES_GET_PACIENTE_REQUEST_FAILURE: 'PACIENTES_GET_PACIENTE_FAILURE',

  // - GET TIENDAS
  PACIENTES_GET_PACIENTES_TIENDAS: 'PACIENTES_GET_PACIENTES_TIENDAS',
  PACIENTES_GET_PACIENTES_TIENDAS_SUCCESS: 'PACIENTES_GET_PACIENTES_TIENDAS_SUCCESS',
  PACIENTES_GET_PACIENTES_TIENDAS_FAILURE: 'PACIENTES_GET_PACIENTES_TIENDAS_FAILURE',

  // - GET PROFESIONES
  PACIENTES_GET_PACIENTES_PROFESIONES: 'PACIENTES_GET_PACIENTES_PROFESIONES',
  PACIENTES_GET_PACIENTES_PROFESIONES_SUCCESS: 'PACIENTES_GET_PACIENTES_PROFESIONES_SUCCESS',
  PACIENTES_GET_PACIENTES_PROFESIONES_FAILURE: 'PACIENTES_GET_PACIENTES_PROFESIONES_FAILURE',

  // - GET IDENTIFICADORES
  PACIENTES_GET_IDENTIFICADORES: 'PACIENTES_GET_IDENTIFICADORES',
  PACIENTES_GET_IDENTIFICADORES_SUCCESS: 'PACIENTES_GET_IDENTIFICADORES_SUCCESS',
  PACIENTES_GET_IDENTIFICADORES_FAILURE: 'PACIENTES_GET_IDENTIFICADORES_FAILURE',

  // - GET PACIENTES GROUPS
  PACIENTES_GET_PACIENTES_GROUPS: 'PACIENTES_GET_PACIENTES_GROUPS',
  PACIENTES_GET_PACIENTES_GROUPS_SUCCESS: 'PACIENTES_GET_PACIENTES_GROUPS_SUCCESS',
  PACIENTES_GET_PACIENTES_GROUPS_FAILURE: 'PACIENTES_GET_PACIENTES_GROUPS_FAILURE',

  // - GET RGPD PACIENTE
  PACIENTES_GET_PACIENTE_RGPD_REQUEST: 'PACIENTES_GET_PACIENTE_RGPD_REQUEST',
  PACIENTES_GET_PACIENTE_RGPD_SUCCESS: 'PACIENTES_GET_PACIENTE_RGPD_SUCCESS',
  PACIENTES_GET_PACIENTE_RGPD_FAILURE: 'PACIENTES_GET_PACIENTE_RGPD_FAILURE',

  // - OPEN RGPD URL PACIENTE
  PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_REQUEST: 'PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_REQUEST',
  PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_SUCCESS: 'PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_SUCCESS',
  PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_FAILURE: 'PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_FAILURE',

  // - DOWNLOAD RGPD URL PACIENTE
  PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_REQUEST: 'PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_REQUEST',
  PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_SUCCESS: 'PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_SUCCESS',
  PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_FAILURE: 'PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_FAILURE',

  // - OPEN RGPD URL PACIENTE
  PACIENTES_OPEN_PACIENTE_URL_RGPD_REQUEST: 'PACIENTES_OPEN_PACIENTE_URL_RGPD_REQUEST',
  PACIENTES_OPEN_PACIENTE_URL_RGPD_SUCCESS: 'PACIENTES_OPEN_PACIENTE_URL_RGPD_SUCCESS',
  PACIENTES_OPEN_PACIENTE_URL_RGPD_FAILURE: 'PACIENTES_OPEN_PACIENTE_URL_RGPD_FAILURE',

  // - DOWNLOAD RGPD URL PACIENTE
  PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_REQUEST: 'PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_REQUEST',
  PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_SUCCESS: 'PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_SUCCESS',
  PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_FAILURE: 'PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_FAILURE',

  // SET RGPD PACIENTE CONDITIONS
  PACIENTES_SET_PACIENTE_RGPD_CONDITIONS: 'PACIENTES_SET_PACIENTE_RGPD_CONDITIONS',
  PACIENTES_SET_PACIENTE_RGPD_CONDITION: 'PACIENTES_SET_PACIENTE_RGPD_CONDITION',

  // SAVE RGPD PACIENTE
  PACIENTES_SAVE_PACIENTE_RGPD_REQUEST: 'PACIENTES_SAVE_PACIENTE_RGPD_REQUEST',
  PACIENTES_SAVE_PACIENTE_RGPD_SUCCESS: 'PACIENTES_SAVE_PACIENTE_RGPD_SUCCESS',
  PACIENTES_SAVE_PACIENTE_RGPD_FAILURE: 'PACIENTES_SAVE_PACIENTE_RGPD_FAILURE',

  // - GET NOTAS PACIENTE
  PACIENTES_GET_PACIENTE_NOTAS_REQUEST: 'PACIENTES_GET_PACIENTE_NOTAS_REQUEST',
  PACIENTES_GET_PACIENTE_NOTAS_REQUEST_SUCCESS: 'PACIENTES_GET_PACIENTE_NOTAS_REQUEST_SUCCESS',
  PACIENTES_GET_PACIENTE_NOTAS_REQUEST_FAILURE: 'PACIENTES_GET_PACIENTE_NOTAS_REQUEST_FAILURE',

  // - SET NOTAS PACIENTE
  PACIENTES_SET_PACIENTE_NOTAS_REQUEST: 'PACIENTES_SET_PACIENTE_NOTAS_REQUEST',
  PACIENTES_SET_PACIENTE_NOTAS_REQUEST_SUCCESS: 'PACIENTES_SET_PACIENTE_NOTAS_REQUEST_SUCCESS',
  PACIENTES_SET_PACIENTE_NOTAS_REQUEST_FAILURE: 'PACIENTES_SET_PACIENTE_NOTAS_REQUEST_FAILURE',

  // - GET INSURANCES PACIENTE
  PACIENTES_GET_PACIENTE_INSURANCES_REQUEST: 'PACIENTES_GET_PACIENTE_INSURANCES_REQUEST',
  PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_SUCCESS: 'PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_SUCCESS',
  PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_FAILURE: 'PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_FAILURE',

  // - CREATE FICHA OPTOMETRICA
  PACIENTES_CREATE_FICHA_OPTOMETRICA_REQUEST: 'PACIENTES_CREATE_FICHA_OPTOMETRICA_REQUEST',
  PACIENTES_CREATE_FICHA_OPTOMETRICA_REQUEST_SUCCESS: 'PACIENTES_CREATE_FICHA_OPTOMETRICA_SUCCESS',
  PACIENTES_CREATE_FICHA_OPTOMETRICA_REQUEST_FAILURE: 'PACIENTES_CREATE_FICHA_OPTOMETRICA_FAILURE',

  // - UPDATE FICHA OPTOMETRICA
  PACIENTES_UPDATE_FICHA_OPTOMETRICA_REQUEST: 'PACIENTES_UPDATE_FICHA_OPTOMETRICA_REQUEST',
  PACIENTES_UPDATE_FICHA_OPTOMETRICA_REQUEST_SUCCESS: 'PACIENTES_UPDATE_FICHA_OPTOMETRICA_SUCCESS',
  PACIENTES_UPDATE_FICHA_OPTOMETRICA_REQUEST_FAILURE: 'PACIENTES_UPDATE_FICHA_OPTOMETRICA_FAILURE',

  // - GET FICHA OPTOMETRICA
  PACIENTES_GET_FICHA_OPTOMETRICA_REQUEST: 'PACIENTES_GET_FICHA_OPTOMETRICA_REQUEST',
  PACIENTES_GET_FICHA_OPTOMETRICA_REQUEST_SUCCESS: 'PACIENTES_GET_FICHA_OPTOMETRICA_SUCCESS',
  PACIENTES_GET_FICHA_OPTOMETRICA_REQUEST_FAILURE: 'PACIENTES_GET_FICHA_OPTOMETRICA_FAILURE',

  // - GET PAISES
  PACIENTES_GET_PACIENTES_PAISES: 'PACIENTES_GET_PACIENTES_PAISES_REQUEST',
  PACIENTES_GET_PACIENTES_PAISES_SUCCESS: 'PACIENTES_GET_PACIENTES_PAISES_SUCCESS',
  PACIENTES_GET_PACIENTES_PAISES_FAILURE: 'PACIENTES_GET_PACIENTES_PAISES_FAILURE',

  // - GET PROVINCIAS
  PACIENTES_GET_PACIENTES_PROVINCIAS: 'PACIENTES_GET_PACIENTES_PROVINCIAS',
  PACIENTES_GET_PACIENTES_PROVINCIAS_SUCCESS: 'PACIENTES_GET_PACIENTES_PROVINCIAS_SUCCESS',
  PACIENTES_GET_PACIENTES_PROVINCIAS_FAILURE: 'PACIENTES_GET_PACIENTES_PROVINCIAS_FAILURE',

  // - GET MUTUAS
  PACIENTES_GET_PACIENTES_MUTUAS: 'PACIENTES_GET_PACIENTES_MUTUAS',
  PACIENTES_GET_PACIENTES_MUTUAS_SUCCESS: 'PACIENTES_GET_PACIENTES_MUTUAS_SUCCESS',
  PACIENTES_GET_PACIENTES_MUTUAS_FAILURE: 'PACIENTES_GET_PACIENTES_MUTUAS_FAILURE',

  // - GET PACIENTE CAMPOS PERSONALIZADOS
  PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS: 'PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS',
  PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_SUCCESS: 'PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_SUCCESS',
  PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_FAILURE: 'PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_FAILURE',

  // - GET PACIENTE CAMPOS DINAMICOS
  PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS: 'PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS',
  PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_SUCCESS: 'PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_SUCCESS',
  PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_FAILURE: 'PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_FAILURE',
  PACIENTES_SET_PACIENTE_CAMPOS_DINAMICOS: 'PACIENTES_SET_PACIENTE_CAMPOS_DINAMICOS',

  // - GET PACIENTE CAMPOS DINAMICOS
  PACIENTES_GET_PACIENTE_ENCARGO_REQUEST: 'PACIENTES_GET_PACIENTE_ENCARGO_REQUEST',
  PACIENTES_GET_PACIENTE_ENCARGO_SUCCESS: 'PACIENTES_GET_PACIENTE_ENCARGO_SUCCESS',
  PACIENTES_GET_PACIENTE_ENCARGO_FAILURE: 'PACIENTES_GET_PACIENTE_ENCARGO_FAILURE',

  GET_ACTIVITY_DATA_REQUEST: 'GET_ACTIVITY_DATA_REQUEST',
  GET_ACTIVITY_NEXT_DATA_REQUEST: 'GET_ACTIVITY_NEXT_DATA_REQUEST',
  GET_ACTIVITY_DATA_SUCCESS: 'GET_ACTIVITY_DATA_SUCCESS',
  PACIENTES_UNSET_PACIENTE_DUPLICADO: 'PACIENTES_UNSET_PACIENTE_DUPLICADO',

  // - GET FOTO PACIENTES
  GET_PHOTO_PACIENTE_REQUEST: 'GET_PHOTO_PACIENTE_REQUEST',
  GET_PHOTO_PACIENTE_REQUEST_SUCCESS: 'GET_PHOTO_PACIENTE_REQUEST_SUCCESS',
  GET_PHOTO_PACIENTE_REQUEST_FAILURE: 'GET_PHOTO_PACIENTE_REQUEST_FAILURE',

};
